import { Button, Form, Input, Modal, Radio, Select, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DealerCodes,
  DealerDetails,
} from "../../../redux/actions/adminActions/adminDealersActions";
import Alertify from "../../../services/alertify";
import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { getQueryParams } from "../../../utilities/getQueryParams";

const { Title } = Typography;

const orderTypeOptions = [
  {
    key: 1,
    label: "Normal Order",
    value: "Normal Order",
  },
  {
    key: 2,
    label: "Blanket Order",
    value: "Blanket Order",
  },
];

const DealerInfoStep = (props) => {
  const [form] = Form.useForm();
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("");

  useEffect(() => {
    if (props.formData) {
      setIsNextDisabled(!props.formData?.dealer_code);
    }
    form.setFieldsValue({
      orderType: props.formData?.orderType || selectedOrderType,
      dealer_code: props.formData?.dealer_code,
      dealerName: props.formData?.dealerName,
      email: props.formData?.email,
      mblNumber: props.formData?.mblNumber,
      gst: props.formData?.gst,
      balance_credit: props.formData?.balance_credit,
    });
  }, [form, props.formData, selectedOrderType]);
  const params = getQueryParams();
  const uuIds = params.UUID;
  const orderIds = params.orderId;
  useEffect(() => {
    // console.log(
    //   "props.formDataprops.formDataprops.formDataprops.formData===============",
    //   props.formData.orderTypes
    // );
    if (uuIds || orderIds) {
      setOpenModal(false);
      setSelectedOrderType(props.formData.orderType);
    } else {
      setOpenModal(true);
    }
  }, [props.formData?.orderType, uuIds, orderIds]);

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form Values:", values);
        props.onNext(values);
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };
  const handleDraft = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("Form Values:", values);
        props.onNext(values);
        window.history.back();
      })
      .catch((errorInfo) => {
        console.error("Validation Failed:", errorInfo);
        Alertify.error("Please fill in all required fields.");
      });
  };
  const goBack = () => {
    window.history.back();
  };
  const authData = useSelector((state) => state.auth_store);
  const dispatch = useDispatch();

  useEffect(() => {
    const data = {
      token: authData.token,
      seller_code: authData.seller_code,
    };
    dispatch(DealerCodes(data))
      .then((response) => {
        // console.log("Dealer Codes are:", response);
      })
      .catch((error) => {
        Alertify.error("Failed to fetch Dealer Codes: " + error.message);
      });
  }, [authData.token, authData.seller_code, dispatch]);
  const handleDealerCodeChange = (value) => {
    const data = {
      dealer_code: value,
    };
    props.setDealerChangeCount(props.dealerChangeCount + 1);
    dispatch(DealerDetails(data))
      .then((response) => {
        const dealerDetails = response.payload?.data?.data;
        form.setFieldsValue({
          dealerName: dealerDetails.company_name,
          dealer_code: dealerDetails.dealer_code,
          email: dealerDetails.email,
          mblNumber:
            dealerDetails.mobile.split(",")[0].trim() ||
            dealerDetails.mobile.split("/")[0].trim() ||
            null,
          // mblNumber: dealerDetails.mobile.split(",")[0].trim() || "",
          gst: dealerDetails.gst,
          balance_credit: dealerDetails.balance_credit,
        });
      })
      .catch((error) => {
        Alertify.error("Failed to fetch Dealer Details: " + error.message);
      });

    setIsNextDisabled(false);
  };
  console.log("dealerChangeCount is:", props.dealerChangeCount);
  return (
    <div className="border rounded-lg p-4 w-full">
      <div className="w-full">
        <Title level={3} className="text-left py-4">
          Dealer Details
        </Title>
      </div>
      {/* Order Type Selection Modal */}
      <Modal
        title={
          <Title level={3} style={{ fontSize: "24px" }}>
            Select Order Type
          </Title>
        }
        centered
        width={600}
        open={openModal}
        onCancel={goBack} // Handle the cross button click
        footer={[
          <div
            key="modal-footer"
            className="flex justify-center items-center w-[100%]"
          >
            <Button
              className=" w-[20%]"
              key="submit"
              type="primary"
              disabled={!selectedOrderType}
              onClick={() => {
                form.setFieldsValue({ orderType: selectedOrderType });
                props.setHeaderOrderType(selectedOrderType);
                setOpenModal(false);
              }}
            >
              SAVE
            </Button>
          </div>,
        ]}
      >
        <div className="my-10 flex justify-center">
          <Radio.Group
            options={orderTypeOptions}
            value={selectedOrderType}
            onChange={(e) => setSelectedOrderType(e.target.value)}
            optionType="button"
            className=" font-semibold"
            size="large"
            buttonStyle="solid"
          />
        </div>
      </Modal>
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <div className="sm:flex">
          <div className="w-full mx-2">
            <Form.Item
              label="Order Type"
              name="orderType"
              rules={[
                {
                  required: true,
                  message: "Please select Order Type",
                },
              ]}
            >
              <Input placeholder="Order Type" disabled />
            </Form.Item>
          </div>
          <div className="w-full mx-2">
            <Form.Item
              label="Dealer Code"
              name="dealer_code"
              rules={[
                {
                  required: true,
                  message: "Please select Dealer Code",
                },
              ]}
            >
              <Select
                showSearch
                className="text-left"
                placeholder="Please select Dealer Code"
                onChange={handleDealerCodeChange}
                options={props.dealerCodes?.dealer_codes.map((code) => ({
                  value: code?.dealer_id,
                  label: (
                    <div className="flex justify-between font-medium">
                      {code?.dealer_id} {code?.name}
                      {code?.status === "inactive" && (
                        <div
                          className="ant-tag ant-tag-volcano m-0"
                          style={{ color: "red" }}
                        >
                          BLOCKED
                        </div>
                      )}
                    </div>
                  ),
                  disabled: code?.status === "inactive",
                  search: `${code?.dealer_id} ${code?.name}`,
                }))}
                filterOption={(input, option) =>
                  option?.search.toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </div>
        </div>
        <div className="sm:flex">
          <div className="w-full sm:w-1/2 mx-2">
            <Form.Item label="Dealer Name" name="dealerName">
              <Input placeholder="Dealer Name" disabled />
            </Form.Item>
          </div>
          <div className="w-full sm:w-1/2 mx-2">
            <Form.Item label="Email Address" name="email">
              <Input type="email" placeholder="Email" disabled />
            </Form.Item>
          </div>
        </div>
        <div className="sm:flex">
          <div className="w-full sm:w-1/2 mx-2">
            <Form.Item label="Mobile Number" name="mblNumber">
              <Input type="number" placeholder="Mobile Number" disabled />
            </Form.Item>
          </div>
          <div className="w-full sm:w-1/2 mx-2">
            <Form.Item label="GST Number" name="gst">
              <Input placeholder="GST01210212" disabled />
            </Form.Item>
          </div>
        </div>
        <div className="w-full sm:w-1/2 mx-2">
          <Form.Item label="Balanced Credit Limit" name="balance_credit">
            <Input placeholder="Balanced Credit Limit" disabled />
          </Form.Item>
        </div>
        <div className="flex justify-between items-center w-full">
          <Button
            className="text-md rounded-lg"
            onClick={props.handlePrev}
            disabled={props.currentStep <= 0}
          >
            <LeftCircleOutlined className="mb-[-3px]" /> PREVIOUS
          </Button>
          <div>
            <Button
              className="text-md rounded-lg mr-4"
              type="primary"
              htmlType="submit"
              onClick={handleDraft}
            >
              SAVE DRAFT
            </Button>
            <Button
              className="text-md rounded-lg"
              type="primary"
              htmlType="submit"
              disabled={isNextDisabled}
              onClick={handleSubmit}
            >
              NEXT <RightCircleOutlined className="mb-[-3px]" />
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default DealerInfoStep;
